import React, {useEffect, useState} from 'react'
import axios from 'axios';
import {Link} from 'react-router-dom';
import loading from '../images/loading.svg'
import config from '../config'
import { useTranslation } from 'react-i18next'
import { formatPrice } from '../utils/formatPrice'
import { useCountry } from '../context/CountryContext'

export default function Products({category}) {
    const { t, i18n } = useTranslation();
    const { country, currency } = useCountry();
    const [products, setProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);
    useEffect(() => {
        setLoadingProducts(true);
        axios.get(`${config.API_URL}/api/product/getAll`, {params: {lang: i18n.language, country, category}})
            .then(responce => {
                setProducts(responce.data);
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => setLoadingProducts(false));
    }, [i18n.language, country, category]);
    if (loadingProducts) {
        return <div className='loading'><img src={loading} alt='none gif'></img></div>
    }
    if (products.length == 0) {
        return <div className='container'><p className='products-empty'>{t('products.empty', 'No playgrounds in this category yet.')}</p></div>
    }
    return (
        <div className='container'>
            <ul className='products'>
                {products.map(product => (
                    <li key={product.id} style={{position: 'relative'}}>
                        <Link to={`/product/${product.id}`}><img src={product.image}
                                                                 alt='none image'></img></Link>
                        {product.soldOut && (
                            <span style={{
                                position: 'absolute', top: '10px', left: '10px',
                                background: '#c0392b', color: '#fff', padding: '4px 10px',
                                fontSize: '13px', fontWeight: 'bold', borderRadius: '4px', zIndex: 1
                            }}>Sold out</span>
                        )}
                        <p>{product.name}</p>
                        <div className='price'>
                            <p>{formatPrice(product.price, currency)}</p>
                            <s>{formatPrice(product.lastPrice, currency)}</s>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}
